import ApiService from "@/services/ApiService";

const REPOSITORY_URL = "actividades";

const ActividadesRepository = {
  crearTrabajoActividad(
    datosFichas,
    idTipoTrabajo,
    fecha,
    esContratado,
    costoTotal,
    comentario,
    datosCrearTrabajoMaquinariaList,
    datosCrearTrabajoPersonalList,
    datosCrearTrabajoTratamientoList
  ) {
    let data = {
      datosFichas,
      idTipoTrabajo,
      fecha,
      esContratado,
      costoTotal,
      comentario,
      datosCrearTrabajoMaquinariaList,
      datosCrearTrabajoPersonalList,
      datosCrearTrabajoTratamientoList,
    };
    return ApiService.post(`${REPOSITORY_URL}/crear_trabajo_actividad`, data);
  },

  // Depracated api, got updated with the actualizarTrabajoActividades Api below. Just keeping it heare just in case :)
  actualizarTrabajo(
    idTrabajoParcela,
    idTipoTrabajo,
    fecha,
    esContratado,
    costoTotal,
    comentario
  ) {
    let data = {
      idTrabajoParcela,
      idTipoTrabajo,
      fecha,
      esContratado,
      costoTotal,
      comentario,
    };
    return ApiService.post(`${REPOSITORY_URL}/actualizar_trabajo`, data);
  },

  actualizarTrabajoActividades(
    idTrabajoParcela,
    idTipoTrabajo,
    fecha,
    esContratado,
    costoTotal,
    comentario,
    trabajosTratamiento,
    trabajosPersonal,
    trabajosMaquinaria
  ) {
    let data = {
      idTrabajoParcela,
      idTipoTrabajo,
      fecha,
      esContratado,
      costoTotal,
      comentario,
      trabajosTratamiento,
      trabajosPersonal,
      trabajosMaquinaria,
    };
    return ApiService.post(
      `${REPOSITORY_URL}/actualizar_trabajo_actividades`,
      data
    );
  },

  borrarTrabajo(idTrabajoParcela) {
    let data = {
      idTrabajoParcela,
    };
    return ApiService.post(`${REPOSITORY_URL}/borrar_trabajo`, data);
  },

  listaTrabajo(
    idEstablecimiento,
    idTemporada,
    idFichasAgricola = null,
    fechaDesde = null,
    fechaHasta = null
  ) {
    let data = {
      idEstablecimiento,
      idTemporada,
      idFichasAgricola,
      fechaDesde,
      fechaHasta,
    };
    return ApiService.get(`${REPOSITORY_URL}/lista_trabajo`, data);
  },

  // Depracated api, got updated with the actualizarTrabajoActividades Api. Just keeping it heare just in case :)
  borrarActividadMaquinaria(idTrabajoMaquinaria) {
    let data = {
      idTrabajoMaquinaria,
    };
    return ApiService.post(
      `${REPOSITORY_URL}/borrar_actividad_maquinaria`,
      data
    );
  },

  // Depracated api, got updated with the actualizarTrabajoActividades Api. Just keeping it heare just in case :)
  borrarActividadPersonal(idTrabajoPersonal) {
    let data = {
      idTrabajoPersonal,
    };
    return ApiService.post(`${REPOSITORY_URL}/borrar_actividad_personal`, data);
  },

  // Depracated api, got updated with the actualizarTrabajoActividades Api. Just keeping it heare just in case :)
  borrarActividadTratamiento(idTrabajoTratamiento) {
    let data = {
      idTrabajoTratamiento,
    };
    return ApiService.post(
      `${REPOSITORY_URL}/borrar_actividad_tratamiento`,
      data
    );
  },

  // Depracated api, got updated with the actualizarTrabajoActividades Api. Just keeping it heare just in case :)
  actualizarActividadMaquinaria(
    idTrabajoMaquinaria,
    idInventario,
    esViaje,
    cantidad
  ) {
    let data = {
      idTrabajoMaquinaria,
      idInventario,
      esViaje,
      cantidad,
    };
    return ApiService.post(
      `${REPOSITORY_URL}/actualizar_actividad_maquinaria`,
      data
    );
  },

  // Depracated api, got updated with the actualizarTrabajoActividades Api. Just keeping it heare just in case :)
  actualizarActividadPersonal(idTrabajoPersonal, idPersonal, totalHoras) {
    let data = {
      idTrabajoPersonal,
      idPersonal,
      totalHoras,
    };
    return ApiService.post(
      `${REPOSITORY_URL}/actualizar_actividad_personal`,
      data
    );
  },

  // Depracated api, got updated with the actualizarTrabajoActividades Api. Just keeping it heare just in case :)
  actualizarActividadTratamiento(
    idTrabajoTratamiento,
    idProductoAgricultor,
    cantidadTotal,
    precioUnitario
  ) {
    let data = {
      idTrabajoTratamiento,
      idProductoAgricultor,
      cantidadTotal,
      precioUnitario,
    };
    return ApiService.post(
      `${REPOSITORY_URL}/actualizar_actividad_tratamiento`,
      data
    );
  },

  //Movimientos financieros ganadería
  listaMovimientosFinancieros(
    idFichaGanadera,
    idSubconcepto,
    fechaDesde,
    fechaHasta
  ) {
    let data = {
      idFichaGanadera,
      idSubconcepto,
      fechaDesde,
      fechaHasta,
    };
    return ApiService.get(`${REPOSITORY_URL}/lista_mov_financiero`, data);
  },

  crearMovimientoFinanciero(idFichaGanadera, datosMovimientos) {
    let data = {
      idFichaGanadera,
      datosMovimientos,
    };
    return ApiService.post(`${REPOSITORY_URL}/crear_mov_financiero`, data);
  },

  actualizarMovimientoFinanciero(
    idMovimientoFinanciero,
    idSubconcepto,
    fecha,
    importe,
    comentario,
    trabajosParcela
  ) {
    let data = {
      idMovimientoFinanciero,
      idSubconcepto,
      fecha,
      importe,
      comentario,
      trabajosParcela,
    };
    return ApiService.post(`${REPOSITORY_URL}/actualizar_movimiento`, data);
  },

  borrarMovimientoFinanciero(idMovimientoFinanciero) {
    let data = {
      idMovimientoFinanciero,
    };
    return ApiService.post(`${REPOSITORY_URL}/borrar_movimiento`, data);
  },

  resumenMovimientoFinanciero(idFichaGanadera) {
    let data = {
      idFichaGanadera,
    };
    return ApiService.get(`${REPOSITORY_URL}/resumen_mov_financiero`, data);
  },
};

export default ActividadesRepository;
